/**
 * Grafana Faro Configuration Types
 */

export interface FaroConfig {
  /**
   * Grafana Faro collector URL
   * Format: https://faro-collector-{region}.grafana.net/collect/{key}
   */
  collectorUrl: string;

  /**
   * Application name (visible in Grafana)
   */
  appName: string;

  /**
   * Application version
   */
  version: string;

  /**
   * Environment name (dev, qa, qa2, uat, preProd, prod, etc.)
   */
  environment: string;
}

/**
 * Retrieves the Grafana Faro configuration from environment variables.
 * Uses the standard REACT_APP_FARO_* variables, falling back to other standard ones if needed.
 *
 * @returns {FaroConfig} The configuration object
 */
export function getFaroConfig(): FaroConfig {
  return {
    collectorUrl: process.env.REACT_APP_FARO_COLLECTOR_URL ?? '',
    appName: process.env.REACT_APP_FARO_APP_NAME ?? 'mgm-identity-oidc-app',
    version: process.env.REACT_APP_BUILD_ID ?? '1.0.0',
    environment: process.env.REACT_APP_FARO_ENVIRONMENT ?? process.env.REACT_APP_ENVIRONMENT ?? 'dev',
  };
}

/**
 * Validates the Grafana Faro configuration.
 *
 * @param {FaroConfig} config The configuration to validate
 * @returns {boolean} True if the configuration is valid, false otherwise
 */
export function validateFaroConfig(config: FaroConfig): boolean {
  if (!config.collectorUrl) {
    return false;
  }
  const urlLower = config.collectorUrl.toLowerCase();
  if (
    urlLower.includes('placeholder') ||
    urlLower.includes('your_key_here') ||
    urlLower.includes('paste_your_key_here')
  ) {
    return false;
  }
  return true;
}
